if (!customElements.get('image-accordion')) {
  customElements.define('image-accordion', class extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };
      this.items = Array.from(this.querySelectorAll('[data-accordion-item]'));
      this.selectedIndex = this.items.findIndex((item) => item.open || item.classList.contains('is-selected'));
      this.images = Array.from(this.querySelectorAll('[data-accordion-image]'));
      this.animations = new Map();
      this.images.forEach((image) => {
        const active = this.classList.contains('is-enhanced') ? image.classList.contains('is-active') : !image.hidden;
        image.classList.toggle('is-active', active);
        image.setAttribute('aria-hidden', String(!active));
        image.hidden = false;
        const img = image.querySelector('img');
        if (img) img.loading = 'eager';
      });
      this.classList.add('is-enhanced');

      this.items.forEach((item, index) => {
        item.querySelector('[data-accordion-trigger]').addEventListener('click', (event) => {
          event.preventDefault();
          if (this.selectedIndex !== index) this.select(index);
        }, options);
      });
      this.addEventListener('shopify:block:select', (event) => {
        const index = this.items.findIndex((item) => item.dataset.blockId === event.detail.blockId);
        if (index !== -1) this.select(index);
      }, options);
    }

    select(index) {
      if (index < 0 || index >= this.items.length) return;
      this.selectedIndex = index;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.items.forEach((item, itemIndex) => {
        const opening = itemIndex === index;
        const titleButton = item.querySelector('.image-accordion__title-button');
        if (titleButton) {
          item.classList.toggle('is-selected', opening);
          titleButton.setAttribute('aria-pressed', String(opening));
          return;
        }
        const previous = this.animations.get(item);
        if (!previous && item.open === opening) return;
        const startHeight = item.getBoundingClientRect().height;
        previous?.cancel();
        this.animations.delete(item);
        item.open = opening;
        const endHeight = item.getBoundingClientRect().height;
        if (reducedMotion) return;

        // Keep the answer rendered until its closing animation finishes.
        item.open = true;
        const animation = item.animate(
          [{ height: `${startHeight}px` }, { height: `${endHeight}px` }],
          { duration: 320, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
        );
        this.animations.set(item, animation);
        animation.onfinish = () => {
          if (this.animations.get(item) !== animation) return;
          item.open = opening;
          this.animations.delete(item);
          animation.cancel();
        };
      });
      this.images.forEach((image, imageIndex) => {
        image.classList.toggle('is-active', imageIndex === index);
        image.setAttribute('aria-hidden', String(imageIndex !== index));
      });
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.animations?.forEach((animation) => animation.cancel());
      this.animations?.clear();
    }
  });
}
